import { FC } from 'react';
import { CheckIcon } from 'shared/icons';
import styles from './Checkbox.module.scss';

type Props = {
    isChecked: boolean;
    toggleChecked: () => void;
    /** <label> text */
    label: string;
};

const Checkbox: FC<Props> = ({ isChecked, toggleChecked, label }) => {
    return (
        <label className={styles.Wrapper}>
            <span className={styles.CheckboxWrapper}>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => toggleChecked()}
                    className={styles.Checkbox}
                />
                <CheckIcon className={styles.CheckIcon} />
                <span className={styles.Backdrop} />
            </span>
            <span className={styles.Label}>{label}</span>
        </label>
    );
};

export default Checkbox;
